import gsap from "gsap";

export class Collapsible {
	constructor() {
		this.collapsibles = [...document.querySelectorAll(".collapsible[id]")];

		if (!this.collapsibles.length) return;

		this.init();
		this.handleInitialURL();
	}

	init() {
		this.collapsibles.forEach((collapsible) => {
			this.setupCollapsible(collapsible);
		});
	}

	setupCollapsible(collapsible) {
		const button = collapsible.querySelector(".collapsible__button");
		const content = collapsible.querySelector(".collapsible__content");
		const text = collapsible.querySelector(".collapsible__text");
		const icon = collapsible.querySelector(".button__icon.collapsible__icon");

		if (!button || !content || !text || !icon) return;

		// Create timeline for this collapsible
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.inOut",
				duration: this.isReducedMotion() ? 0 : 0.25,
			},
		});

		// Define animation sequence
		timeline
			.fromTo(
				content,
				{
					height: 0,
					visibility: "hidden",
				},
				{
					height: "auto",
					visibility: "visible",
					immediateRender: false,
				},
				0
			)
			.to(
				icon,
				{
					rotate: 90,
				},
				0
			);

		// Check if this collapsible should start open
		const isInitiallyOpen = button.getAttribute("aria-expanded") === "true";

		if (isInitiallyOpen) {
			// Set initial open state
			timeline.progress(1);
		} else {
			timeline.reverse();
		}

		// Handle button clicks
		button.addEventListener("click", () => {
			const expanded = button.getAttribute("aria-expanded") === "true";

			if (!expanded) {
				// Opening - play the animation
				timeline.play();
				button.setAttribute("aria-expanded", "true");
				this.updateURL(collapsible.id);
			} else {
				// Closing - reverse the animation
				timeline.reverse();
				button.setAttribute("aria-expanded", "false");
				this.clearURL();
			}
		});
	}

	isReducedMotion() {
		return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	}

	handleInitialURL() {
		const hash = window.location.hash.slice(1);
		if (hash) {
			try {
				const collapsible = document.getElementById(hash);
				if (collapsible?.classList.contains("collapsible")) {
					const button = collapsible.querySelector(".collapsible__button");
					button?.dispatchEvent(new Event("click"));
					collapsible.scrollIntoView({ behavior: "smooth" });
				}
			} catch (err) {
				console.error(err);
			}
		}
	}

	updateURL(collapsibleId) {
		window.history.replaceState(null, "", `#${collapsibleId}`);
	}

	clearURL() {
		const url = window.location.pathname + window.location.search;
		window.history.replaceState(null, "", url);
	}
}
